// Reveals one server-rendered Reports API token without persisting it.
// Copy uses the shared copy-to-clipboard controller from the view.
// Usage: data-controller="bidwise-client-api-token" with token and toggle targets.
import { Controller } from "stimulus"

const TOKEN_PREVIEW_CHARACTER_COUNT = 4

export default class extends Controller {
  static targets = [ "token", "toggle" ]

  // Replaces the fully masked no-JavaScript fallback with a recognizable token preview.
  connect() {
    // Read the server-rendered attribute because reconnecting a cached page may
    // leave the input property holding the masked preview from its prior connection.
    this.apiToken = this.tokenTarget.getAttribute("value")
    this.revealed = false
    this.renderToken()
  }

  // Toggles the input's visual masking.
  toggle() {
    this.revealed = !this.revealed
    this.renderToken()
  }

  // Keeps the visible value and Reveal control synchronized with the current state.
  renderToken() {
    this.tokenTarget.type = "text"
    this.tokenTarget.value = this.revealed ? this.apiToken : this.maskedToken()
    this.toggleTarget.textContent = this.revealed ? "Hide" : "Reveal"
    this.toggleTarget.setAttribute("aria-pressed", this.revealed ? "true" : "false")
  }

  // Preserves four identifying characters while masking every remaining character.
  maskedToken() {
    const visibleCharacterCount = Math.min(TOKEN_PREVIEW_CHARACTER_COUNT, this.apiToken.length)
    return `${this.apiToken.slice(0, visibleCharacterCount)}${"*".repeat(this.apiToken.length - visibleCharacterCount)}`
  }
}
